export const OLD_PASSWORD_FIELD_NAME = 'oldPassword';
export const NEW_PASSWORD_FIELD_NAME = 'newPassword';
export const REPEAT_PASSWORD_FIELD_NAME = 'repeatPassword';

export const TOKEN_CLAIMS = {
    CLIENT_ID: 'clientId',
    TENANT: 'tenant',
} as const;
